<div
  #dropdownRef="ngbDropdown"
  ngbDropdown
  class="dropdown"
  dropdownClass="custom-dropdown"
  container="body"
  placement="bottom-end"
  autoClose="true">
  <div class="dropdown-toggle-container" ngbDropdownToggle>
    <div class="three-dot-icon">
      <span></span>
      <span></span>
      <span></span>
    </div>
  </div>
  <div ngbDropdownMenu class="dropdown-menu-start arrow_box" aria-labelledby="dropdownMenuLink">
    <div class="col options">
      <span class="menu-arrow"></span>

      <!-- Edit Option -->
      @if (!content.hidden) {
        <button
          type="button"
          class="col pointer p-0 d-flex align-items-center py-1 ps-2 hover-text border-0 bg-transparent text-start w-100"
          (click)="onOpenEditAssetModal()"
          aria-label="Edit asset">
          <img ngSrc="assets/svg/edit.svg" width="14" height="14" alt="Edit Icon" />
          <span class="ms-2 f-10 _700 text-uppercase">Edit</span>
        </button>
      }

      <!-- Add Variant Option -->
      @if (!content.hidden) {
        <button
          type="button"
          class="col pointer p-0 d-flex align-items-center py-1 ps-2 hover-text border-0 bg-transparent text-start w-100"
          (click)="onOpenEditAssetModal(true)"
          aria-label="Add variant">
          <img ngSrc="assets/svg/add.svg" width="14" height="14" alt="Add Icon" />
          <span class="ms-2 f-10 _700 text-uppercase">Add Variant</span>
        </button>
      }

      <!-- Duplicate Option -->
      @if (!content.hidden) {
        <button
          type="button"
          class="col pointer p-0 d-flex align-items-center py-1 ps-2 hover-text border-0 bg-transparent text-start w-100"
          (click)="onDuplicateAsset()"
          aria-label="Duplicate asset">
          <img ngSrc="assets/svg/duplicate.svg" width="14" height="14" alt="Duplicate Icon" />
          <span class="ms-2 f-10 _700 text-uppercase">Duplicate</span>
        </button>
      }

      <!-- Hide/Activate Option -->
      <button
        type="button"
        class="col pointer p-0 d-flex align-items-center py-1 ps-2 hover-text border-0 bg-transparent text-start w-100"
        (click)="onHideAsset()"
        [attr.aria-label]="content.hidden ? 'Activate asset' : 'Hide asset'">
        <img
          [ngSrc]="content.hidden ? 'assets/svg/eye-active-asset.svg' : 'assets/svg/eye-hide-asset.svg'"
          width="14"
          height="14"
          alt="Visibility Icon"
          style="color: #181e39" />
        <span class="ms-2 f-10 _700 text-uppercase">
          {{ content.hidden ? 'Activate' : 'Hide' }}
        </span>
      </button>

      <!-- Delete Option -->
      @if (shouldShowDelete()) {
        <button
          type="button"
          class="col pointer p-0 d-flex align-items-center py-1 ps-2 hover-text border-0 bg-transparent text-start w-100"
          (click)="onDeleteAsset()"
          aria-label="Delete asset">
          <img ngSrc="assets/svg/delete.svg" width="14" height="14" alt="Delete Icon" />
          <span class="ms-2 f-10 _700 text-uppercase">Delete</span>
        </button>
      }

      <!-- Move To Option -->
      @if (shouldShowMoveTo()) {
        <button
          type="button"
          class="col pointer p-0 d-flex align-items-center py-1 ps-2 hover-text border-0 bg-transparent text-start w-100"
          (click)="onMoveToModalOpen_()"
          aria-label="Move asset to another position">
          <img ngSrc="assets/svg/move.svg" width="14" height="14" alt="Move To Icon" />
          <span class="ms-2 f-10 _700 text-uppercase">Move To</span>
        </button>
      }
    </div>
  </div>
</div>
